import axios from 'axios'

/**
 * @desc Fetches Supplier Pricebook
 */
export const downloadPricebookExcel = (supplierId) =>
  axios
    .get(`/authenticated/pricebook/excel?supplierId=${supplierId}`, {
      responseType: 'blob'
    })
    .then((res) => res.data)

/**
 * @desc Fetches Supplier Price Change workbook
 */
export const downloadPriceChangeExcel = () =>
  axios
    .get('/authenticated/pricebook/price-change/excel', {
      responseType: 'blob'
    })
    .then((res) => res.data)
